import React, { ReactNode } from 'react';
import { PaymentHistoryStore } from './payment-history.store';

const PaymentHistoryContext = React.createContext<PaymentHistoryStore | null>(null);

export const PaymentHistoryProvider = ({ children }: { children: ReactNode }) => {
   const [store] = React.useState<PaymentHistoryStore>(() => new PaymentHistoryStore());

   return <PaymentHistoryContext.Provider value={store}>{children}</PaymentHistoryContext.Provider>;
};

export const usePaymentHistory = () => {
   const ctx = React.useContext(PaymentHistoryContext);
   if (!ctx) {
      throw new Error('usePaymentHistory must be used inside PaymentHistoryProvider');
   }

   return ctx;
};
